const React = require("react");
const { useI18next } = require("gatsby-plugin-react-i18next");
const LinkCard = require("../LinkCard/LinkCard.jsx").default;
const LinkGrid = require("../LinkCard/LinkGrid.jsx").default;
const data = require("../../data/excursions.json");

function matchesFilter(minutes, filter) {
  if (filter === "all") return true;
  if (filter === "<60") return minutes < 60;
  if (filter === "60-90") return minutes >= 60 && minutes <= 90;
  if (filter === "90-120") return minutes > 90 && minutes <= 120;
  if (filter === ">120") return minutes > 120;
  return true;
}

const ExcursionsGrid = () => {
  const { language, defaultLanguage } = useI18next?.() || {};
  const lang = language || defaultLanguage || "fr";
  const fallbackLang = defaultLanguage || "fr";

  const excursions = React.useMemo(() => {
    const src = data && Array.isArray(data.entries) ? data.entries : [];
    return src.map((e) => {
      const t =
        (e.i18n && (e.i18n[lang] || e.i18n[fallbackLang] || e.i18n.fr)) || {};
      return {
        id: e.id,
        title: t.name || e.name || "",
        description: t.description || "",
        href: e.website || t.website || "",
        emoji: t.emoji || e.emoji || "",
        image: e.image || null,
        secondaryHref: e.mapsUrl || t.mapsUrl || "",
        minutes: typeof e.minutes === "number" ? e.minutes : null,
      };
    });
  }, [lang, fallbackLang]);

  const [filter, setFilter] = React.useState("all");

  const filterCounts = React.useMemo(() => {
    const counts = {
      all: excursions.length,
      "<60": 0,
      "60-90": 0,
      "90-120": 0,
      ">120": 0,
    };
    for (const e of excursions) {
      counts["<60"] += matchesFilter(e.minutes, "<60") ? 1 : 0;
      counts["60-90"] += matchesFilter(e.minutes, "60-90") ? 1 : 0;
      counts["90-120"] += matchesFilter(e.minutes, "90-120") ? 1 : 0;
      counts[">120"] += matchesFilter(e.minutes, ">120") ? 1 : 0;
    }
    return counts;
  }, [excursions]);

  const visible = excursions.filter((e) => matchesFilter(e.minutes, filter));

  return (
    <>
      <div className="restaurants-filter" role="toolbar" aria-label="Filtrer les excursions par durée">
        <div className="rf-list">
          <button
            type="button"
            className={`rf-chip ${filter === "all" ? "active" : ""}`}
            aria-pressed={filter === "all"}
            onClick={() => setFilter("all")}
          >
            <span className="rf-text">
              Toutes <span className="rf-count">({filterCounts.all})</span>
            </span>
          </button>
          <button
            type="button"
            className={`rf-chip ${filter === "<60" ? "active" : ""}`}
            aria-pressed={filter === "<60"}
            onClick={() => setFilter("<60")}
          >
            <span className="rf-text">
              Moins d’1 h <span className="rf-count">({filterCounts["<60"]})</span>
            </span>
          </button>
          <button
            type="button"
            className={`rf-chip ${filter === "60-90" ? "active" : ""}`}
            aria-pressed={filter === "60-90"}
            onClick={() => setFilter("60-90")}
          >
            <span className="rf-text">
              1 h à 1 h30 <span className="rf-count">({filterCounts["60-90"]})</span>
            </span>
          </button>
          <button
            type="button"
            className={`rf-chip ${filter === "90-120" ? "active" : ""}`}
            aria-pressed={filter === "90-120"}
            onClick={() => setFilter("90-120")}
          >
            <span className="rf-text">
              1 h30 à 2 h <span className="rf-count">({filterCounts["90-120"]})</span>
            </span>
          </button>
          <button
            type="button"
            className={`rf-chip ${filter === ">120" ? "active" : ""}`}
            aria-pressed={filter === ">120"}
            onClick={() => setFilter(">120")}
          >
            <span className="rf-text">
              Plus de 2 h <span className="rf-count">({filterCounts[">120"]})</span>
            </span>
          </button>
        </div>
      </div>
      <LinkGrid columns={3}>
        {visible.map((e) => (
          <LinkCard
            key={e.id}
            title={e.title}
            href={e.href}
            emoji={e.emoji}
            image={e.image}
            description={e.description}
            secondaryHref={e.secondaryHref}
            tag={
              e.minutes >= 150
                ? "Plus de 2 h de route"
                : `~${Math.round(e.minutes / 5) * 5} min de route`
            }
          />
        ))}
      </LinkGrid>
    </>
  );
};

module.exports = ExcursionsGrid;
